import React from "react";
import "./Popup.scss";

/**
 * @typedef {Object} PopupProps
 * @property {() => void} onClose - Function to close the popup
 * @property {boolean} login - Whether this is a login popup
 * @property {boolean} share - Whether this is a share popup
 * @property {boolean} playlist - Whether this is a playlist popup
 * @property {boolean} small - Whether to use small popup styling
 * @property {boolean} fullHeight - Whether to use full height
 * @property {boolean} red - Whether to use red styling
 * @property {boolean} termsOfService - Whether this is terms of service popup
 * @property {boolean} searchLikeTag - Whether this is search like tag popup
 * @property {boolean} shortLink - Whether this is short link popup
 * @property {boolean} confirmAction - Whether this is confirmation popup
 * @property {boolean} initialNote - Whether this is initial note popup
 * @property {boolean} playlistPassword - Whether this is playlist password popup
 * @property {any} children - Child components to render
 */

/**
 * @param {PopupProps} props
 */
const Popup = (props) => (
  <div
    className={`Popup-background ${
      props.playlistPassword ? " Popup-password-background" : ""
    }`}
    onClick={props.onClose}
  >
    <div
      className={`Popup${props.small ? " Popup-small" : ""}${
        props.login ? " Popup-login" : ""
      }${props.playlist ? " Popup-playlist" : ""}${
        props.fullHeight ? " Popup-full-height" : ""
      }${props.share ? " Popup-share" : ""}${
        props.fullHeight ? " Popup-full-height" : ""
      }${props.red ? " Popup-red" : ""}${
        props.termsOfService ? " Popup-tos" : ""
      }${props.searchLikeTag ? " Popup-search-like-tags" : ""}${
        props.shortLink ? " Popup-short-link" : ""
      }${props.confirmAction ? " Popup-confirm-action" : ""}${
        props.initialNote ? " Popup-initial-note" : ""
      }${props.playlistPassword ? " Popup-password" : ""}`}
      onClick={e => {
        // if we get a click on the foreground of the popup, don't propagate
        // to the background and close the popup
        e.stopPropagation();
      }}
    >
      {props.children}
    </div>
  </div>
);

export default Popup;
